export function chain<A extends unknown[], R>(
	...funcs: Array<((...args: A) => R) | false | undefined>
): (...args: A) => R | void {
	return (...args: A) => {
		let result!: R | void;

		for (const fn of funcs) {
			if (fn) {
				result = fn(...args);
				if (
					args[0] &&
					typeof args[0] === "object" &&
					"isPropagationStopped" in args[0] &&
					typeof args[0].isPropagationStopped === "function" &&
					// eslint-disable-next-line @typescript-eslint/no-unsafe-call
					args[0].isPropagationStopped()
				) {
					break;
				}
			}
		}

		return result;
	};
}
